import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditCostProfileRequest(
  state: State,
  { costProfile }: Boundaries["editCostProfile"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.costProfile.uuid === costProfile.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { costProfile, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { costProfile, request: setRequestStateToPending() }];
}

function handleEditCostProfileSuccess(
  state: State,
  costProfile: Boundaries["editCostProfile"]["success"],
): State {
  const index = state.findIndex(
    (req) => req.costProfile.uuid === costProfile.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { costProfile, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { costProfile, request: setRequestStateToSuccess() }];
}

function handleEditCostProfileFailure(
  state: State,
  { costProfile }: Boundaries["editCostProfile"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.costProfile.uuid === costProfile.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { costProfile, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { costProfile, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editCostProfileRequested]: handleEditCostProfileRequest,
    [events.editCostProfileSucceeded]: handleEditCostProfileSuccess,
    [events.editCostProfileFailed]: handleEditCostProfileFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
